import React, { Component } from 'react'

class AddSubject extends Component {
    render() {
        return (
            <div style={{ padding: "10px" }}>

                <form className="was-validated">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="card">
                                <div className="card-header bg-primary" style={{ color: "white" }}>Add Subject Information</div>
                                <div className="card-body">
                                    <div className="row">
                                        <div className="form-group col-lg-6">
                                            <label for="fname"><b>Subject Code</b></label>
                                            <input type="text" class="form-control" id="uname" placeholder="Subject Code"
                                                name="fname" required />
                                            <div class="valid-feedback">Valid.</div>
                                            <div class="invalid-feedback">Please fill out this field.</div>
                                        </div>
                                        <div className="form-group col-lg-6">
                                            <label for="lname"><b>Subject Name</b></label>
                                            <input type="text" class="form-control" id="pwd" placeholder="Subject Name"
                                                name="lname" required />
                                            <div class="valid-feedback">Valid.</div>
                                            <div class="invalid-feedback">Please fill out this field.</div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="form-group col-lg-6">
                                            <label for="fname"><b>Book Name</b></label>
                                            <input type="text" class="form-control" id="uname" placeholder="Book Name"
                                                name="fname" required />
                                            <div class="valid-feedback">Valid.</div>
                                            <div class="invalid-feedback">Please fill out this field.</div>
                                        </div>
                                        <div className="form-group col-lg-6">
                                            <label for="lname"><b>Subject Teacher</b></label>
                                            {/* <input type="text" class="form-control" id="pwd" placeholder="Class Teacher"
                                                name="lname" required /> */}
                                            <select class="form-control">
                                                <option>Deepak</option>
                                                <option>Rahul</option>
                                                <option>Sandeep</option>
                                                <option>Ashutosh</option>
                                            </select>
                                            <div class="valid-feedback">Valid.</div>
                                            <div class="invalid-feedback">Please fill out this field.</div>
                                        </div>
                                    </div>
                                   

                                    {/* <div class="row">
                                        <div class="col-lg-12 " style={{ textAlign: "end" }}>
                                            <button type="submit" class="btn btn-primary">Submit</button>
                                            <button type="reset" class="btn btn-success">Reset</button>
                                            <button class="btn btn-primary">Back</button>
                                        </div>
                                    </div> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </form>

            </div>
        );
    }
}

export default AddSubject;